import request from '../request'

export function fetchList(params) {
    return request({
        url: `/finance-service/subpackageCost/list`,
        params,
    })
}

// 上传 Excel 文件
export function upload(data) {
    return request({
        url: `/finance-service/subpackageCost/import`,
        method: "post",
        data
    })
}

// 统计合同进度页四项金额合计
export function fetchSummaryStat() {
    return request({
        url: `/project-service/finContract/summary/stat`,
    })
}